import React, { Fragment } from "react";
import { Box, TableRow, TableCell, Button, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { t } from "i18next";
import StorageIcon from '@mui/icons-material/Storage';
import StyledTypography from "../common/StyledTypography";
import EditButton from "../common/editButton";
import handleNavigate from "../common/customFunctions/handleNavigate";
import { useDispatch } from "react-redux";
import { setAddHubServerConfig } from "../store/addHubServerConfigSlice";

export default function ServerHubConfigTableRow({
  row,
  handleClick,
  isItemSelected,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  function handleClickEdit(event) {
    dispatch(setAddHubServerConfig(row))
    handleNavigate(event, navigate, "/addEditHubServerConfig");
  }
  return (
    <Fragment>
      <TableRow
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.name}
        selected={isItemSelected}
        sx={{ cursor: "pointer" }}
      >
        <TableCell />
        <TableCell
          onClick={(event) => handleClick(event, row.name)}
          align="left"
        >
          <StyledTypography variant="subtitle2">{row.name}</StyledTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.name)}
          align="left"
        >
          <StyledTypography variant="subtitle2">
            {row.description}
          </StyledTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.name)}
          align="left"
        >
          <StyledTypography variant="subtitle2">
            {row.serverId}
          </StyledTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.name)}
          align="left"
        >
          <StyledTypography variant="subtitle2">{row.status}</StyledTypography>
        </TableCell>
        <TableCell align="left">
          <Box
            sx={{
              textAlign: "center",
              width: "100%",
              display: "flex",
              flexFlow: "row",
              gap: 1
            }}
          >
            <EditButton onClick={handleClickEdit} />

            <Tooltip title={t("Edit Attributes")}>
              <Button
                variant="contained"
                sx={{
                  height: "36px",
                  backgroundColor: theme.palette.custom.buttonColor,
                  color: theme.palette.custom.buttonTextColor,
                  "&:hover": {
                    backgroundColor: theme.palette.custom.buttonHoverColor,
                    color: theme.palette.custom.buttonHoverTextColor,
                    boxShadow: "none",
                  },
                  float: "right",
                  width: "min-content",
                  whiteSpace: "nowrap",
                  padding: "1rem",
                }}
                onClick={(event) => {
                  handleNavigate(event, navigate, `/hubServerAttributes?serverId=${row.id}`);
                }}
              >
                <StorageIcon
                  sx={{
                    color: theme.palette.custom.buttonTextColor,
                    fontSize: 24,
                  }}
                />
              </Button>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
ServerHubConfigTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
  isItemSelected: PropTypes.bool,
};
